import { createSelector } from 'reselect';

const selectLogisticsOrders = (state: any) => state.logisticsOrders;

export const selectLogisticsOrdersCurrentItem = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.current);

export const selectLogisticsOrdersListItems = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.list);

export const selectLogisticsOrdersItemById = (itemId: any) =>
    createSelector(selectLogisticsOrdersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLogisticsOrdersQueryItems = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.query);

export const selectLogisticsOrdersCreatedItem = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.create);

export const selectLogisticsOrdersPrintItem = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.print);

export const selectLogisticsOrdersUpdatedItem = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.update);

export const selectLogisticsOrdersExportItem = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.export);


export const selectLogisticsOrdersReadItem = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.read);

export const selectLogisticsOrdersDeletedItem = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.delete);

export const selectLogisticsOrdersSearchedItems = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.search);

export const selectLogisticsOrdersItemsCount = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.count);

export const selectLogisticsOrdersItemsFilter = createSelector([selectLogisticsOrders], (logisticsOrders) => logisticsOrders.filter);